var poll_header_default = {
  "title": "VPPUG",
  "image": "TIcVk",
  "webview": "gJ0rt"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
